<template>

   <el-form class="text-left" :inline="inline" :model="form">
<!--
     {{old_password}} | {{old_password2}} | {{change}}
       <el-form-item v-if="change && !newPsw" label="Existing Password" :label-width="formLabelWidth">
         <password v-model="old_password" :toggle="toggle" />
       </el-form-item>

       <div v-if="!newPsw && (change && old_password === old_password2)">
-->
         <el-form-item label="New Password" :label-width="formLabelWidth">
          <password v-model="form.password" :toggle="toggle" />
        </el-form-item>

        <el-form-item label="Confirm New Password" :label-width="formLabelWidth">
          <password v-model="form.c_password" :toggle="toggle" />
        </el-form-item>
<!--
      </div>
-->
     </el-form>

</template>

<script>

import PostMixins from '@/mixins/PostMixins'

import Password from 'vue-password-strength-meter'


export default {

  mixins: [PostMixins],

  components: {
    Password
  },

  props: {
    value: {
      required: true
    },

    inline: {
      type: Boolean,
      default: true
    },

    change: {
      type: Boolean,
      default: false
    },

    newPsw: {
      type: Boolean,
      default: false
    },

    toggle: {
      type: Boolean,
      default: true
    }

  },



  watch: {

    value: function (d) {
      this.form = d
    }

  },




  methods: {

    changePassword () {
      this.changePsw = true
    },

    resetPassword () {

      this.$alert('Reset e-mail to ' + this.form.email, 'Reset Password', {
        confirmButtonText: '  OK',
        callback: action => {
        }
      })

    }

  },

  data () {
    return {
      changePsw: false,
      resetPsw: false,
      form: this.value,
      old_password: null,
      old_password2: null,
      formLabelWidth: '174px'
    }
  }

}

</script>



// WEBPACK FOOTER //
// PasswordForm.vue?dc851368